




































































































import {Vue, Component, Provide} from 'vue-property-decorator';
import Class from '@/models/class';

import Paginition from '@/components/Paginition.vue';
import FilterMenu from '@/components/FilterMenu.vue';
import {Filter} from '@/utils/Filter';
import {Utils} from '@/utils/Utils';
import {API} from '@/services/api/api';
import {mapActions, mapGetters} from 'vuex';

@Component({
  methods: {
    ...mapActions(['showSuccessToast', 'showErrorToast']),
  },
  computed: {...mapGetters(['roleList'])},

  components: {
    Paginition,
    FilterMenu,
  },
})
export default class ClassList extends Vue {
  //List titles
  public header = [
    {
      name: 'Class Name',
      value: 'className',
      headerType: 'text',
      sortable: true,
      asdcOrder: true,
      filter: true,
    },
    {
      name: 'Roles',
      value: 'surveyorGroup',
      headerType: 'text',
      sortable: true,
      asdcOrder: true,
      filter: true,
    },
    {
      name: 'Status',
      value: 'isActive',
      headerType: 'text',
      sortable: false,
      filter: false,
      bindClass: 'text-center',
    },

    {
      name: 'Created',
      value: 'created',
      headerType: 'date',
      sortable: true,
      asdcOrder: true,
      filter: true,
    },
    {
      name: 'Edit',
      value: 'edit',
      headerType: 'text',
      sortable: false,
      filter: false,
      bindClass: 'text-center',
    },

    {
      name: 'Delete',
      value: 'delete',
      headerType: 'text',
      sortable: false,
      filter: false,
      bindClass: 'text-center',
    },
  ];

  startingPoint = 0; //pagination starting point
  endingPoint = 5; //pagination ending point
  curentSort = ''; //current sort on which header

  //Store Variable
  showSuccessToast: any;
  showErrorToast: any;
  roleList: any;

  //Modal & Loader Variable
  isScreenLoading = false;
  modalVisible = false;
  loadingBtnStatus = false;
  modalConfimationMsg: any = null;
  modalTitle: any = null;

  classId: number = null;
  deleteStatus: any = null;
  asdcOrder = true;
  classList: Class[];
  filteredClassList: Class[] = [];

  mounted() {
    this.getClassList();
  }

  //Get class lists from APIs
  async getClassList() {
    this.isScreenLoading = true;
    this.classList = [];
    this.filteredClassList = [];
    try {
      const response = await API.fetchClassList();

      if (response.data) {
        let surveyorClasses = response.data;
        this.isScreenLoading = false;
        const data2 = surveyorClasses.filter((obj: any) => {
          obj.surveyorGroup = this.getsurveorGroupRoles(obj.surveyorGroups);
          return obj;
        });
        this.classList = this.filteredClassList = [...data2];
        setTimeout(() => {
          this.resetFilter(true);
        }, 500);
      } else {
        this.showErrorToast({msg: response.message});
      }
    } catch (error) {
      this.showErrorToast({msg: 'Network error'});
    } finally {
      this.isScreenLoading = false;
    }
  }

  // format date to human readable string
  formatDate(originalDate: string) {
    let formattedDate = Utils.formatDate(originalDate);
    return formattedDate;
  }

  //sorting list
  clickOnSort(header: any) {
    if (this.curentSort !== header.value) {
      this.curentSort = header.value;
      this.asdcOrder = true;
    }
    let sorted = Utils.sortData(this.asdcOrder, header, this.filteredClassList);
    this.asdcOrder = sorted;
  }

  //filter data based upon string parameters
  filterOnText(emittedFilterParams: any) {
    let filteredData = Filter.filterOnTextData(emittedFilterParams, this.classList);
    this.filteredClassList = filteredData;
    this.resetPagination();
  }

  //filter data based upon date parameters
  filterOnDate(emittedFilterParams: any) {
    let filteredData = Filter.filterOnDateData(emittedFilterParams, this.classList);
    this.filteredClassList = filteredData;
    this.resetPagination();
  }

  //reset all filters and show current list of data
  resetFilter(isDefaultList: boolean) {
    if (isDefaultList) {
      this.filteredClassList = this.classList;
      this.resetPagination();
    }
  }

  displayDeleteModal(recordId: number) {
    this.classId = recordId;
    this.modalVisible = true;
    this.modalTitle = 'Delete Confirmation';
    this.modalConfimationMsg = 'Are you sure want to delete ?';
    this.deleteStatus = true;
  }

  //show activate/deactivate  confirmation  modal
  displayStatusModal(recordId: number, recordEnableStatus: boolean) {
    this.classId = recordId;
    let msg;
    if (recordEnableStatus) {
      msg = 'Deactivate';
    } else {
      msg = 'Activate';
    }
    this.modalVisible = true;
    this.modalTitle = `${msg} Confirmation`;
    msg = msg.toLowerCase();
    this.modalConfimationMsg = `Are you sure want to ${msg} ?`;
    this.deleteStatus = false;
  }

  //call delete or activate/deactivate method based upon confirmation
  async deleteOrChangeStatus() {
    try {
      const response = this.deleteStatus ? await this.deleteClass(this.classId) : await this.changeStatus(this.classId);

      const message = this.deleteStatus ? 'Record deleted successfully' : 'Record updated successfully';

      if (response) {
        this.showSuccessToast({msg: response.message});
        this.getClassList();
      } else {
        this.showErrorToast({msg: response.error});
      }
    } catch (error) {
      this.showErrorToast({msg: 'Network error'});
    }
  }

  async deleteClass(classId) {
    return await API.deleteClassById(classId);
  }

  async changeStatus(classId: number) {
    const surveyorClass = this.classList.find((me) => me.classId === classId);
    return await API.changeClassStatus(classId, !surveyorClass.isActive);
  }

  //reset pagination to first page
  resetPagination() {
    const pagination: any = this.$refs.pagination;
    setTimeout(() => {
      pagination.reset();
    }, 150);
  }

  //pagination value listener show data based on pagination
  onPaginitionValueChange(startingPoint: number, endingPoint: number) {
    this.startingPoint = startingPoint - 1;
    this.endingPoint = endingPoint;
  }

  //Go to edit Class page
  editClass(classId: number) {
    this.$router.push({
      path: 'edit-class/' + classId,
    });
  }

  //Got to create Class page
  goToCreateClass() {
    this.$router.push('/create-class');
  }

  //Get surveor group from state roleList
  getsurveorGroupRoles(data: any) {
    const resultArray = this.roleList.list.filter((elem) => data.find(({groupId}) => elem.groupId === groupId));
    const groupNames = resultArray.map((a) => a.groupName);

    return groupNames.join(', ');
  }
}
